import { render, staticRenderFns } from "./WizardStepJobMatchPreviousJobtitles.vue?vue&type=template&id=3b4dfb58&lang=pug&"
import script from "./WizardStepJobMatchPreviousJobtitles.vue?vue&type=script&lang=ts&"
export * from "./WizardStepJobMatchPreviousJobtitles.vue?vue&type=script&lang=ts&"
import style0 from "./WizardStepJobMatchPreviousJobtitles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4dfb58')) {
      api.createRecord('3b4dfb58', component.options)
    } else {
      api.reload('3b4dfb58', component.options)
    }
    module.hot.accept("./WizardStepJobMatchPreviousJobtitles.vue?vue&type=template&id=3b4dfb58&lang=pug&", function () {
      api.rerender('3b4dfb58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard-pages/jobmatch-steps/WizardStepJobMatchPreviousJobtitles.vue"
export default component.exports